<template>
  <center>
    <div v-if="id > 0" class="card card-body agatrs-card-style">
      <div class="col-md-12">
        <Header :pageTitle="pageTitle" class="card-container"></Header>

        <!-- don't need a form, each change has its own modal with submit inside it. -->
        <!-- <form @submit.prevent="updateTransaction"> -->
        <div class="row align-center">
          <div class="col-md-3">
            <base-input
              type="text"
              disabled
              label="Order Number"
              placeholder="Order Number"
              v-model="transaction.orderId"
            >
            </base-input>
          </div>

          <div class="col-md-3">
            <base-input
              type="text"
              disabled
              label="Requisition Number"
              placeholder="Requisition Number"
              v-model="transaction.requisitionNumber"
            >
            </base-input>
          </div>
        </div>

        <div class="row align-center">
          <div class="col-md-6">
            <label>Order Assigned to Logistics:</label>
            <logistics-user-select
              :is-read-only="isViewOnly"
            ></logistics-user-select>
          </div>
        </div>

        <div class="row align-center">
          <div class="col-md-6">
            <label>Order Assigned to Finance:</label>
            <finance-user-select
              :is-read-only="isViewOnly"
            ></finance-user-select>
          </div>
        </div>

        <div class="row align-center">
          <div class="col-md-6">
            <label>Order Assigned to Partner Nation:</label>
            <partner-user-select
              :countryId="agreementInfoSelectedCountryId"
              :is-read-only="isViewOnly"
              :isPartnerAccount="isPartnerAccount"
            ></partner-user-select>
          </div>
        </div>

        <div class="col-sm-6 more-top-padding">
          <label for="methodOfPayment">Method of Payment</label>
          <!-- <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="ModeOfPayToolTip_Name" :name="ModeOfPayToolTip_Name" :description="ModeOfPayToolTip_Description" :editable="editable"></tool-tip> -->

          <br />
          <el-radio-group
            v-model="orderMetadata.paymentMethodId"
            :disabled="checkMonetary()"
            v-validate="'required'"
            data-vv-as="Method of Payment"
            name="paymentMethod"
            :error="getError('paymentMethod')"
          >
            <el-radio
              tabindex="0"
              @change="viewModal"
              v-for="paymentMethod in paymentMethods"
              :label="paymentMethod.paymentMethodId"
              :key="paymentMethod.paymentMethodId"
              >{{ paymentMethod.name }}</el-radio
            >
          </el-radio-group>
          <br />
        </div>

        <div class="row align-center">
          <div class="col-md-6">
            <div style="width: 50% !important">
              <label for="status">Status</label>
              <v-select
                v-if="showDropDown"
                id="status"
                v-model="selectedStatusOption"
                @input="onStatusChange"
                label="name"
                :disabled="
                  selectedStatusLabel.toLowerCase().trim() === 'draft' ||
                  selectedStatusLabel.toLowerCase().trim() === 'completed' ||
                  selectedStatusLabel.toLowerCase().trim() === 'cancelled' ||
                  isFinanceApprovalNeeded ||
                  isViewOnly
                "
                name="StatusDropdown"
                :options="statusOptions"
                placeholder="Select"
              >
              </v-select>
              <p
                v-if="
                  selectedStatusLabel.toLowerCase().trim() === 'draft' ||
                  selectedStatusLabel.toLowerCase().trim() === 'completed' ||
                  selectedStatusLabel.toLowerCase().trim() === 'cancelled'
                "
              >
                Order status for orders in {{ selectedStatusLabel }} cannot be
                modified.
              </p>
              <p v-if="isFinanceApprovalNeeded">
                Order requires Finance approval to adjust the phase.
              </p>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="cancel"
          >
            Close
          </base-button>
          <base-button
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="updateTransactionLocal"
          >
            Confirm
          </base-button>
        </div>
      </template>

      <br />
      <br />

      <modal
        :show.sync="modals.notice"
        headerClasses="justify-content-center"
        type="notice"
      >
        <h4 slot="header" class="title title-up">CHANGE METHOD OF PAYMENT</h4>
        <hr />
        <div class="container">
          <div class="form-group">
            <!-- <base-checkbox v-model="sendAssignerCopy"
              >Send Me a Copy</base-checkbox
            > -->
          </div>
          <div class="row">
            <div class="col-md-12">
              <base-input label="Please specify a reason for change: ">
                <textarea
                  class="form-control"
                  placeholder="Add a brief description"
                  rows="5"
                  v-model="preOrder.remarks"
                ></textarea>
              </base-input>
            </div>
          </div>
        </div>
        <template slot="footer">
          <div class="container alert_footer">
            <base-button
              type="danger"
              class="alert_footer_button btn_extra_small btn_info"
              @click.native="cancel"
            >
              Close
            </base-button>
            <base-button
              type="primary"
              class="alert_footer_button btn_extra_small btn_info"
              @click.native="updatePreOrder"
            >
              Confirm
            </base-button>
          </div>
        </template>
      </modal>
      <div class="row">
        <div class="col-md-3 center">
          <base-button @click="returnToTable()" class="btn btn-primary">
            <i class="tim-icons icon-double-left center-btn-content"></i> Return
            to table
          </base-button>
        </div>
      </div>
      <!-- </form> -->
    </div>

    <div v-else>
      <div class="col-md-12">
        <Header :pageTitle="noPermissionTitle" class="card-container"></Header>

        <!-- don't need a form, each change has its own modal with submit inside it. -->
        <!-- <form @submit.prevent="updateTransaction"> -->
        <div class="row align-center">
          <label>Order Assigned to Logistics:</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 center">
          <router-link :to="'/admin/transactions'" class="btn btn-secondary"
            ><span> Back </span></router-link
          >
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { Select, Option, Radio, RadioGroup } from "element-ui";
import { Modal } from "@/components";

import Header from "@/components/App/Header.vue";
import LogisticsUserSelect from "@/components/App/order/user/LogisticsUserSelect";
import FinanceUserSelect from "@/components/App/order/user/FinanceUserSelect";
import PartnerUserSelect from "@/components/App/order/user/PartnerUserSelect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "@/axios";
import Util from "@/util/util";
import orderStatusSignalR from "@/services/order_status_SignalR";

export default {
  name: "AdminEditTransaction",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    LogisticsUserSelect,
    FinanceUserSelect,
    PartnerUserSelect,
    Modal,
  },
  data() {
    return {
      id: this.$route.params.id,
      modals: {
        notice: false,
      },
      sendAssignerCopy: false,
      selectedStatusLabel: "",
      selectedStatus: "",
      statusOptions: [],
      allStatuses: [],
      note: null,
      preOrder: {},
      showDropDown: false,
      oldPaymentOfMenthod: "",
      onlyDraft: false,
      orderStatusMap: null,
      unsubscribeSignalR: null,
    };
  },
  computed: {
    ...mapGetters({
      transaction: "transactions/transaction",
      financeUsers: "users/financeUsers",
      logisticsUsers: "users/logisticsUsers",
      orderMetadata: "orderMetadata/orderMetadata",
      paymentMethods: "paymentmethod/paymentMethods",
      agreementInfoSelectedCountryId:
        "agreementInformation/agreementInfoSelectedCountryId",
      isPartnerAccount: "authentication/isPartnerAccount",
      isFinance: "authentication/isFinance",
      isSponsor: "authentication/isSponsor",
      isSuperAdmin: "authentication/isSuperAdmin",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
    }),
    isViewOnly() {
      return (
        this.$route.path === `/admin/transactions/view/${this.$route.params.id}`
      );
    },
    isFinanceApprovalNeeded() {
      if (this.isSuperAdmin) {
        return false;
      } else if (
        this.selectedStatusLabel == "BILLED" &&
        (!this.isFinance || !this.isSponsor)
      ) {
        return true;
      } else return false;
    },
    pageTitle() {
      return this.isViewOnly ? "View Transaction" : "Edit Transaction";
    },
    noPermissionTitle() {
      return "The Transaction Doesn't Exist or You Don't Have The Permission To Edit It.";
    },
    // Computed v-model for vue-select — always a full object so the label resolves.
    selectedStatusOption: {
      get() {
        if (!this.selectedStatus) return null;
        return {
          id: this.selectedStatus,
          name: this.selectedStatusLabel,
        };
      },
      set(option) {
        if (option) {
          this.selectedStatus = option.id;
          this.selectedStatusLabel = option.name;
        }
      },
    },
  },
  async mounted() {
    // promise.all weill run thes calls concurrently lets see if the
    // sever can handle these runs

    // lets batch all the lookups
    // Get all statuses first so the map is ready
    this.$loaderApp.addRequest();

    await this.getAllStatuses();

    await Promise.all([
      this.getFinanceUsers(false),
      this.getPaymentMethods(),
      this.getLogisticsUsers(false),
    ]);

    // try this second
    await Promise.all([
      this.getTransaction(this.id),
      this.loadAgreementInformation(this.id),
      this.getPreOrder(this.id),
    ]);

    // Load partner nation users after getting agreement info (which has the country)
    if (this.agreementInfoSelectedCountryId) {
      await this.getPartnerNationUsers(this.agreementInfoSelectedCountryId);
    }

    if (this.id > 0) {
      this.oldPaymentOfMenthod = this.orderMetadata.paymentMethodId;
    }

    // Load status options after getting current status
    await this.filterValues();

    // Subscribe to real-time order status updates via SignalR
    // This prevents stale data issues when the same order is open in multiple tabs
    await this.setupSignalRSubscription();

    this.$loaderApp.completeRequest();
    this.showDropDown = true;
  },
  beforeDestroy() {
    // Cleanup SignalR subscription when leaving the page
    if (this.unsubscribeSignalR) {
      this.unsubscribeSignalR();
    }
    orderStatusSignalR.unsubscribeFromOrder(parseInt(this.id));
  },
  methods: {
    ...mapActions({
      getLogisticsUsers: "users/getLogisticsUsers",
      getFinanceUsers: "users/getFinanceUsers",
      getPartnerNationUsers: "users/getPartnerNationUsers",
      updateTransaction: "transactions/updateTransaction",
      getTransaction: "transactions/getTransaction",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      loadAgreementInformation: "agreementInformation/loadAgreementInformation",
    }),
    async setupSignalRSubscription() {
      try {
        // Connect to SignalR hub first
        await orderStatusSignalR.connect();
        
        // Subscribe to order status updates for this order
        await orderStatusSignalR.subscribeToOrder(parseInt(this.id));
        
        // Register callback for status changes
        this.unsubscribeSignalR = orderStatusSignalR.onStatusChanged((data) => {
          if (data.orderId === parseInt(this.id)) {
            // Status was changed (possibly from another tab)
            // Update the local state and re-filter options
            this.selectedStatus = data.newStatusId;
            this.selectedStatusLabel = data.newStatusName;
            this.filterValues();
          }
        });
      } catch (err) {
        // SignalR subscription failed silently - not critical for functionality
      }
    },
    async onStatusChange(option) {
      if (option) {
        this.selectedStatus = option.id;
        this.selectedStatusLabel = option.name;
      }
      await this.updateOrderStatus();
    },
    checkMonetary() {
      if (this.orderMetadata.paymentMethodId === Util.MONETARY) {
        return true;
      }
      return false;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    viewModal(e) {
      this.selectedUserId = e;
      this.modals.notice = true;
    },
    async cancel(e) {
      await this.getPreOrder();
      this.modals.notice = false;
    },
    async getPreOrder() {
      var res = await axios.get(`/api/orders/preorder/${this.id}`);
      this.preOrder = res.data;
    },
    async getCurrentOrderStatus() {
      const res = await axios.get(`/api/orders/order/currentstatus/${this.id}`);
      this.selectedStatus = parseInt(res.data);
      if (this.orderStatusMap) {
        this.selectedStatusLabel = this.orderStatusMap[this.selectedStatus];
      }
    },
    returnToTable() {
      this.$router.push("/admin/transactions");
    },
    async getAllStatuses() {
      const response = await axios.get("/api/orderstatuses");
      this.allStatuses = response.data.map((item) => ({
        ...item,
        id: parseInt(item.id),
      }));
      this.orderStatusMap = this.allStatuses.reduce((map, item) => {
        map[item.id] = item.name;
        return map;
      }, {});
    },
    async filterValues() {
      // Fetch allowed statuses from the backend service which enforces
      // business rules (backward-only, no draft/cancelled, no returned for monetary, etc.)
      try {
        const res = await axios.get(`/api/orders/${this.id}/allowed-statuses`);
        const data = res.data;

        // Update current status from server response
        this.selectedStatus = data.currentStatusId;
        this.selectedStatusLabel = data.currentStatusName;

        // Map options into the shape the v-select expects.
        // Only selectable statuses — current status is NOT in the list.
        this.statusOptions = data.options.map((opt) => ({
          id: opt.id,
          name: opt.name,
          sortOrder: opt.sortOrder,
        }));

        this.onlyDraft =
          data.currentStatusName.toLowerCase().trim() === "draft";
      } catch {
        // Fallback: if the endpoint fails, keep current state
      }
    },
    async updateOrderStatus(e) {
      try {
        //this.duringSubmit = true;
        this.$loaderApp.addRequest();
        if (this.selectedOrderId !== "") {
          const options = {
            "Content-Type": "application/json",
            config: { showToast: true },
          };
          var data = {
            id: this.selectedStatus,
            name: this.selectedStatusLabel,
            sortOrder: 0,
          };
          var res = await axios.post(
            `/api/orders/orderstatus/${this.id}`,
            data,
            options
          );
          if (res.status === 200) {
            // reload the order
            await this.getTransaction(this.id);
            // Refresh the dropdown to reflect the new current status
            await this.filterValues();
            this.$loaderApp.completeRequest();
          }
        }
      } catch (e) {
        const errorMessage =
          e?.response?.data || "Error: Unable to update order status.";
        this.$toast.error(errorMessage);
        // Refresh dropdown to reflect actual current status from server
        await this.filterValues();
        this.$loaderApp.completeRequest();
      }
    },
    async updatePreOrder() {
      try {
        this.$loaderApp.addRequest();
        this.paymentMethodChanged(this.orderMetadata.paymentMethodId);
        if (!(this.preOrder === undefined || this.preOrder.orderId === 0)) {
          if (
            this.orderMetadata.paymentMethodId === Util.MONETARY &&
            this.oldPaymentOfMenthod !== this.orderMetadata.paymentMethodId
          ) {
            this.preOrder["isMethodToMonetary"] = true;
          } else {
            this.preOrder["isMethodToMonetary"] = false;
          }
          await this.savePreOrderAdmin();
        } else {
          this.modals.notice = true;
          this.$toast.error("Error on saving");
        }
        this.$loaderApp.completeRequest();
      } catch (e) {
        this.$loaderApp.completeRequest();
        this.modals.notice = true;
        this.$toast.error("Error on updating");
      }
      return;
    },
    async savePreOrderAdmin() {
      try {
        let ret = await this.$validator.validateAll();
        if (ret) {
          const dataToSend = Object.assign({}, this.preOrder);
          const options = {
            "Content-Type": "application/json",
          };
          //The DODAAC must be null or a valid 6 character string when sent to the server.  If it is an empty string set it to null.
          if (
            !Util.isNull(dataToSend) &&
            Util.isNullOrEmpty(dataToSend.dodAac)
          ) {
            dataToSend.dodAac = null;
          }
          if (this.preOrder.remarks) {
            if (!Util.isNullOrEmpty(this.preOrder.remarks.trim())) {
              await axios.post("/api/orders", dataToSend, options);
              await this.getTransaction(this.id);
              await this.getPreOrder(this.id);
              this.modals.notice = false;
            } else {
              this.modals.notice = true;
              this.$toast.error("Remarks cannot be empty");
            }
          } else {
            this.$toast.error("Remarks cannot be empty");
          }
        }
      } catch (e) {
        this.$toast.error("Error on updating");
      }
    },
    async updateTransactionLocal(id) {
      let ctx = this;
      await ctx.updateTransaction();
    },
    paymentMethodChanged(paymentMethodId) {
      try {
        if (paymentMethodId === Util.MONETARY) {
          if (
            this.preOrder.lssTypeId === Util.STANDARD ||
            this.preOrder.lssTypeId === Util.OPEN_ENDED
          ) {
            this.preOrder.hasAcsaCeiling = "YES";
            this.preOrder.paymentMethodId = paymentMethodId;
            return;
          }
          if (
            this.preOrder.lssTypeId === Util.SME_LOAN ||
            this.preOrder.lssTypeId === Util.LIFT_AND_SUSTAIN ||
            this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT
          ) {
            this.preOrder.hasAcsaCeiling = "NO";
            this.preOrder.paymentMethodId = paymentMethodId;
            return;
          }
        }
        this.preOrder.hasAcsaCeiling = null;
        this.preOrder.acsaCeilingJustification = null;
        this.preOrder.paymentMethodId = paymentMethodId;
      } catch (e) {
        this.$toast.error("An error occurred");
      }
    },
  },
};
</script>

<style>
.more-width {
  width: 50%;
}

.center-btn-content {
  height: 18px;
  margin-right: 3px;
}
</style>
